import _objectSpread2 from '../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import '../../node_modules/core-js/modules/es.array.includes.js';
import { block } from '../../utils/block.js';
import './Dropdown.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgCheck } from '../../static/icons/general/check.svg.js';

const _excluded = ["children", "icon", "isChecked", "onKeyDown", "onClick", "className"];
const b = block('dropdown');
const DropdownItem = _ref => {
  let {
      children,
      icon,
      isChecked,
      onKeyDown,
      onClick,
      className = ''
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const onKeyDownCallback = e => {
    if ([' ', 'Enter'].includes(e.key)) {
      onClick === null || onClick === void 0 ? void 0 : onClick();
    }
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
  };
  return /*#__PURE__*/jsxs("li", _objectSpread2(_objectSpread2({
    className: b('item', {
      checked: isChecked
    }).mix(className),
    "aria-checked": isChecked,
    onKeyDown: onKeyDownCallback,
    tabIndex: -1,
    onClick: onClick
  }, rest), {}, {
    children: [isChecked && /*#__PURE__*/jsx(SvgCheck, {
      className: b('check-icon'),
      "aria-hidden": true
    }), icon && /*#__PURE__*/jsx("div", {
      className: b('item-icon'),
      children: icon
    }), children]
  }));
};

export { DropdownItem };
